import { useMutation } from '@apollo/client';
import DELETE_BOOKMARK from 'graphql/mutations/bookmarks/DeleteBookmark.graphql';
import { getIDFromPK } from 'utilities';

export default function useDeleteBookmarkMutation() {
  return useMutation(DELETE_BOOKMARK, {
    update(cache, { data: { deleteEpubBookmark } }) {
      if (!deleteEpubBookmark) {
        console.warn(
          'Failed to delete an EpubBookmark record through GraphQL. It may not exist in the database.',
        );

        return;
      }

      cache.modify({
        fields: {
          epubBookmarksByEpub(existingBookmarks, { readField }) {
            const id = getIDFromPK(
              deleteEpubBookmark.epubBookmarkId,
              'EpubBookmarkNode',
            );
            const cacheId = `EpubBookmarkNode:${id}`;
            const updatedEdges = existingBookmarks.edges.filter(
              (existingBookmark) => cacheId !== existingBookmark.node.__ref,
            );
            return {
              __typename: existingBookmarks.__typeName,
              edges: updatedEdges,
            };
          },
        },
      });
    },
  });
}
